import { useEffect } from "react";

export function useClickAway<T extends HTMLElement = HTMLElement>(
    ref: React.RefObject<T>,
    onClick: () => void
) {
    useEffect(() => {
        const documentClick = (event: MouseEvent) => {
            if (event.target !== ref.current) {
                onClick();
            }
        };

        document.addEventListener("click", documentClick);

        return () => {
            document.removeEventListener("click", documentClick);
        };
    }, [ref, onClick]);
}
